export default __webpack_public_path__ + "static/media/solution-rej.b64e046a.svg";